import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _get from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/get";
import _inherits from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/inputtext/inputtextview
 */
import View from "../view";
import "../../theme/components/inputtext/inputtext.css";
/**
 * The text input view class.
 *
 * @extends module:ui/view~View
 */

var InputTextView = /*#__PURE__*/function (_View) {
  _inherits(InputTextView, _View);

  var _super = _createSuper(InputTextView);

  /**
   * @inheritDoc
   */
  function InputTextView(locale) {
    var _this;

    _classCallCheck(this, InputTextView);

    _this = _super.call(this, locale);
    /**
     * The value of the input.
     *
     * @observable
     * @member {String} #value
     */

    _this.set('value');
    /**
     * The `id` attribute of the input (i.e. to pair with a `<label>` element).
     *
     * @observable
     * @member {String} #id
     */


    _this.set('id');
    /**
     * The `placeholder` attribute of the input.
     *
     * @observable
     * @member {String} #placeholder
     */


    _this.set('placeholder');
    /**
     * Controls whether the input view is in read-only mode.
     *
     * @observable
     * @member {Boolean} #isReadOnly
     */


    _this.set('isReadOnly', false);
    /**
     * Set to `true` when the field has some error. Usually controlled via
     * {@link module:ui/labeledinput/labeledinputview~LabeledInputView#errorText}.
     *
     * @observable
     * @member {Boolean} #hasError
     */


    _this.set('hasError', false);
    /**
     * The `id` of the element describing this field, e.g. when it has
     * some error, it helps screen readers read the error text.
     *
     * @observable
     * @member {Boolean} #ariaDescribedById
     */


    _this.set('ariaDescribedById');

    var bind = _this.bindTemplate;

    _this.setTemplate({
      tag: 'input',
      attributes: {
        type: 'text',
        class: ['ck', 'ck-input', 'ck-input-text', bind.if('hasError', 'ck-error')],
        id: bind.to('id'),
        placeholder: bind.to('placeholder'),
        readonly: bind.to('isReadOnly'),
        'aria-invalid': bind.if('hasError', true),
        'aria-describedby': bind.to('ariaDescribedById')
      },
      on: {
        input: bind.to('input')
      }
    });
    /**
     * Fired when the user types in the input. Corresponds to the native
     * DOM `input` event.
     *
     * @event input
     */


    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(InputTextView, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      _get(_getPrototypeOf(InputTextView.prototype), "render", this).call(this);

      var setValue = function setValue(value) {
        _this2.element.value = !value && value !== 0 ? '' : value;
      };

      setValue(this.value); // Bind `this.value` to the DOM element's value.
      // We cannot use `value` DOM attribute because removing it on Edge does not clear the DOM element's value property.

      this.on('change:value', function (evt, name, value) {
        setValue(value);
      });
    }
    /**
     * Moves the focus to the input and selects the value.
     */

  }, {
    key: "select",
    value: function select() {
      this.element.select();
    }
    /**
     * Focuses the input.
     */

  }, {
    key: "focus",
    value: function focus() {
      this.element.focus();
    }
  }]);

  return InputTextView;
}(View);

export { InputTextView as default };